// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"156":"MobileLandscape","362":"Modal","552":"Chatbot"}[chunkId] + ".chunk.min.css";
};